import { render } from "./ApprovalCheck.vue?vue&type=template&id=2c15a566"
import script from "./ApprovalCheck.vue?vue&type=script&lang=js"
export * from "./ApprovalCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__